import { Avatar, Col, Collapse, Row } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import GeneralBloc from "../../../bloc/general_bloc";
import ProfileBloc from "../../../bloc/profile_bloc";
import RouteBloc from "../../../bloc/route_bloc";
import App_header from "../../component/app_header/app_header";
import App_header_title_simple from "../../component/app_header_title/app_header_title_simple";
import Base_screen from "../base/base_screen/base_screen";
import UserAccessBloc from "../../../bloc/user_access_bloc";
import HomeBloc from "../../../bloc/home_bloc";
import Config from "../../../Config";
import { ReactComponent as ArrowDownIcon } from "../../../ArrowDownIcon.svg";
import { ReactComponent as ChevronRightIcon } from "../../../ChevronRight2.svg";

import "./faq_screen.css";
import App_search_filter from "../../component/app_filters/app_search_filter";
import FaqBloc from "../../../bloc/faq_bloc";

const { Panel } = Collapse;

const sectionOneData = [
    {
        question: 'What is Takaful Mortgage Portal?',
        ans: 'Takaful Mortgage Portal is an added digitalization platform that enables you to conduct an end-to-end paperless sales process up front, thereby providing an efficient and effective platform to conduct your new business submission.'
    },
    {
        question: 'How can I use the Takaful Mortgage Portal?',
        ans: 'Takaful Mortgage Portal is an added digitalization platform that enables you to conduct an end-to-end paperless sales process up front, thereby providing an efficient and effective platform to conduct your new business submission.'
    },
    {
        question: 'Would I be able to log into the Takaful Mortgage Portal while I am overseas?',
        ans: 'Takaful Mortgage Portal is an added digitalization platform that enables you to conduct an end-to-end paperless sales process up front, thereby providing an efficient and effective platform to conduct your new business submission.'
    },
    {
        question: 'Are there any other languages provided besides English?',
        ans: 'Takaful Mortgage Portal is an added digitalization platform that enables you to conduct an end-to-end paperless sales process up front, thereby providing an efficient and effective platform to conduct your new business submission.'
    },
    {
        question: 'How can I update my personal details?',
        ans: 'Takaful Mortgage Portal is an added digitalization platform that enables you to conduct an end-to-end paperless sales process up front, thereby providing an efficient and effective platform to conduct your new business submission.'
    },
    {
        question: 'What are the operating hours for the Takaful Mortgage Portal services?',
        ans: 'Takaful Mortgage Portal is an added digitalization platform that enables you to conduct an end-to-end paperless sales process up front, thereby providing an efficient and effective platform to conduct your new business submission.'
    },
];

const sectionTwoData = [
    {
        question: 'How can I obtain my user ID and password to log in for the first time?',
        ans: 'Takaful Mortgage Portal is an added digitalization platform that enables you to conduct an end-to-end paperless sales process up front, thereby providing an efficient and effective platform to conduct your new business submission.'
    },
    {
        question: 'Can I create / change my login ID?',
        ans: 'Takaful Mortgage Portal is an added digitalization platform that enables you to conduct an end-to-end paperless sales process up front, thereby providing an efficient and effective platform to conduct your new business submission.'
    },
    {
        question: 'What are the criteria in creating a password? ',
        ans: 'Takaful Mortgage Portal is an added digitalization platform that enables you to conduct an end-to-end paperless sales process up front, thereby providing an efficient and effective platform to conduct your new business submission.'
    },
    {
        question: 'What would happen if I forgot to log in using the temporary password?',
        ans: 'Takaful Mortgage Portal is an added digitalization platform that enables you to conduct an end-to-end paperless sales process up front, thereby providing an efficient and effective platform to conduct your new business submission.'
    },
    {
        question: 'What should I do if I forget my password?',
        ans: 'Takaful Mortgage Portal is an added digitalization platform that enables you to conduct an end-to-end paperless sales process up front, thereby providing an efficient and effective platform to conduct your new business submission.'
    },
    {
        question: 'What would happen if I keyed in the wrong password several times?',
        ans: 'Takaful Mortgage Portal is an added digitalization platform that enables you to conduct an end-to-end paperless sales process up front, thereby providing an efficient and effective platform to conduct your new business submission.'
    },
    {
        question: 'How can I unlock my user ID?',
        ans: 'Takaful Mortgage Portal is an added digitalization platform that enables you to conduct an end-to-end paperless sales process up front, thereby providing an efficient and effective platform to conduct your new business submission.'
    },
    {
        question: 'If I have trouble logging in with the provided ID and password, what should I do?',
        ans: 'Takaful Mortgage Portal is an added digitalization platform that enables you to conduct an end-to-end paperless sales process up front, thereby providing an efficient and effective platform to conduct your new business submission.'
    },
    {
        question: 'Is there an expiry to my account?',
        ans: 'Takaful Mortgage Portal is an added digitalization platform that enables you to conduct an end-to-end paperless sales process up front, thereby providing an efficient and effective platform to conduct your new business submission.'
    },
    {
        question: 'Will I be notified before my ID expires?',
        ans: 'Takaful Mortgage Portal is an added digitalization platform that enables you to conduct an end-to-end paperless sales process up front, thereby providing an efficient and effective platform to conduct your new business submission.'
    },
];
const sectionThreeData = [
    {
        question: 'I have created and saved a Quotation/Proposal in one device. Can I open the same data using other devices?',
        ans: 'Takaful Mortgage Portal is an added digitalization platform that enables you to conduct an end-to-end paperless sales process up front, thereby providing an efficient and effective platform to conduct your new business submission.'
    },
    {
        question: 'I have wrongly keyed in a customers common personal details in Quotation and Proposal. Do I need to amend it manually in each module?',
        ans: 'Takaful Mortgage Portal is an added digitalization platform that enables you to conduct an end-to-end paperless sales process up front, thereby providing an efficient and effective platform to conduct your new business submission.'
    },
    {
        question: 'I have data in the Quotation. Will the system save the details permanently?',
        ans: 'Takaful Mortgage Portal is an added digitalization platform that enables you to conduct an end-to-end paperless sales process up front, thereby providing an efficient and effective platform to conduct your new business submission.'
    },
    {
        question: 'What would happen if I forgot to log in using the temporary password?',
        ans: 'Takaful Mortgage Portal is an added digitalization platform that enables you to conduct an end-to-end paperless sales process up front, thereby providing an efficient and effective platform to conduct your new business submission.'
    },
    {
        question: 'If the device or connection data turns off while data was being keyed in to Quotation or Proposal, will the information be saved?',
        ans: 'Takaful Mortgage Portal is an added digitalization platform that enables you to conduct an end-to-end paperless sales process up front, thereby providing an efficient and effective platform to conduct your new business submission.'
    },
    {
        question: 'Can I start to create a proposal in the Proposal menu directly upon login?',
        ans: 'Takaful Mortgage Portal is an added digitalization platform that enables you to conduct an end-to-end paperless sales process up front, thereby providing an efficient and effective platform to conduct your new business submission.'
    }
];

const sectionOneHeader = {
    title: 'Section 1 - Account Information & Functions',
    desc: 'Have questions? We are here to help'
}

const sectionTwoHeader = {
    title: 'Section 2 - Login & Password Management ',
    desc: 'Have questions? We are here to help'
}

const sectionThreeHeader = {
    title: 'Section 3 - Quotation & Proposal',
    desc: 'Have questions? We are here to help'
}

class FaqScreenV2 extends Component {
    constructor(props) {
        super(props);
        let routeParams = RouteBloc.extractRouteParamsFromProps(props);
        this.state = {
            route: routeParams,
            userDataHeader: null,
            userSettings: {},
            section: this.props.match.params.section,
            faqData: null,
            faqSectionData: null,
            keyword: ''
        };
    }
    componentDidMount() {
        let userData = UserAccessBloc.getUserData();
        let userSettings = UserAccessBloc.getUserSettings();
        let name = "";
        let role = "";
        let branch = "";
        let profile = [];
        if (userData) {
            name = userData ? userData.displayName : "";
            role = userData ? userData.designationTitle : "";
            profile = userSettings ? userSettings.module.profile : [];
            this.setState({
                userData: userData,
                userDataHeader: HomeBloc.getUserData(name, role, branch),
                userSettings: profile,
            });
        }
        this.getFaqData();
        this.getFaqSectionData();
    }

    async getFaqData() {
        this.setState({ loading: true });
        let result = await FaqBloc.getFaqCategories('');
        this.setState({
            faqData: result.data,
            loading: false
        });
        console.log('faq', result)
    }

    async getFaqSectionData() {
        this.setState({ loading: true });
        let result = await FaqBloc.getFaqByCategory(this.state.keyword, this.getSectionId());
        this.setState({
            faqSectionData: result.data,
            loading: false
        });
        console.log(result)
    }

    capitalizeWords(str) {
        return str
            .toLowerCase()
            .split(' ')
            .map(function (word) {
                return word[0].toUpperCase() + word.substr(1);
            })
            .join(' ');
    }

    getCurrentSectionHeader() {
        let currentHeader = this.state.faqData ? this.state.faqData.filter((item) => item.faq_category.id == this.getSectionId()) : null;
        return (
            currentHeader &&
            <App_header_title_simple title={this.capitalizeWords(currentHeader[0].faq_category.nameEN)} description={'Have questions? We are here to help'} />
        );
    }

    getCurrentSectionData() {
        return (
            this.state.faqSectionData && this.state.faqSectionData.map((data, index) => {
                return (
                    <div className="faqscreen_collapse_container mt-3 d-flex align-items-center">
                        <Collapse
                            className="p-1 d-flex align-items-center justify-items-center"
                            bordered={false}
                            expandIconPosition={"start"}
                            style={{
                                backgroundColor: "white",
                                display: "flex",
                            }}
                            defaultActiveKey={[0]}
                            expandIcon={(isActive) =>
                                isActive.isActive ? <ArrowDownIcon className="faqscreen_collapse_icon" />
                                    : <ChevronRightIcon className="faqscreen_collapse_icon" />
                            }

                        >
                            <Panel
                                key={data.faq.id}
                                header={data.faq.questionEN || ""}
                                className="faqscreen_collapse_title "
                            >
                                <div className="faqscreen_collapse_desc ml-4 orange_border_side" dangerouslySetInnerHTML={{ __html: data.faq.answerEN }}>

                                    {/* {data.faq.answerEN} */}
                                </div>
                            </Panel>
                        </Collapse>
                    </div>
                )
            })
        );
    }

    getUserDataHeader() {
        return this.state.userDataHeader;
    }
    getUserData() {
        return this.state.userData;
    }
    getSectionId() {
        return this.props.match.params.section;
    }
    getEntity() {
        return this.state.route.entity;
    }

    getUserSettings() {
        return this.state.userSettings;
    }

    generateProfileSettingValue() {
        let userSettings = this.getUserSettings().info[0].value;
        let userData = this.getUserData();
        let value = userData[userSettings];
        return value;
    }

    getInitial(name) {
        let result = GeneralBloc.mergeIntoInitialName(name);
        return result;
    }

    handleOnClickSearch = () => {
        this.getFaqSectionData();
    }

    handleChangeKeyword = (keyword) => {
        this.setState({ keyword: keyword }, () => {
            this.getFaqSectionData();
        })
    }

    render() {
        return (
            <>
                <Base_screen
                    listener={() => {
                        this.getEntity();
                    }}
                >
                    {this.getSectionId() ? (
                        <>
                            <App_header
                                data={this.getUserDataHeader()}
                                route={this.getEntity()}
                            />
                            <div
                                style={{
                                    marginTop: 110,
                                    paddingLeft: 42,
                                    paddingRight: 42,
                                    fontFamily: 'Lato'
                                }}
                            >
                                <div className="row m-0 w-100">
                                    <div className="col-8">
                                        {this.getCurrentSectionHeader()}
                                    </div>
                                    <div className="col-4">
                                        <App_search_filter
                                            title={"Search for a solution"}
                                            onChangeKeyword={this.handleChangeKeyword}
                                            onClickSearch={this.handleOnClickSearch}
                                        />
                                    </div>
                                </div>
                                <div className="w-100 px-3 pb-4">
                                    {this.getCurrentSectionData()}
                                </div>

                            </div>
                        </>
                    ) : null}
                </Base_screen>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    userGlobal: state.user.value,
    globalFilterBy: state.filter.value,
    globalSearchBy: state.searchBy.value,
    userConfigGlobal: state.userConfig.value,
});

export default withRouter(connect(mapStateToProps)(FaqScreenV2));
